import { zonedTimeToUtc } from 'date-fns-tz'

export const useTimezoneDate = () => {
  const selectedTimezone = useState<string>(
    'selected-timezone',
    () => 'America/Guayaquil'
  )

  function combineFechaHora(
    fecha: { toString: () => string },
    hora: Date
  ): string {

    const dateStr = fecha.toString()

    const hh = String(hora.getHours()).padStart(2, "0")
    const mm = String(hora.getMinutes()).padStart(2, "0")

    const local = `${dateStr} ${hh}:${mm}:00`

    const utcDate = zonedTimeToUtc(local, selectedTimezone.value)

    return utcDate.toISOString()
  }

  return {
    selectedTimezone,
    combineFechaHora
  }
}